import { SessionState, sessionManager } from "@/utils/sessionManager";
import React, { useEffect, useState } from "react";

export const SessionLogoutWarning: React.FC = () => {
  const [, setSessionState] = useState<SessionState>(sessionManager.getState());

  useEffect(() => {
    const unsubscribe = sessionManager.subscribe((newState) => {
      setSessionState(newState);
    });

    return unsubscribe;
  }, []);

  // const handleLogoutNow = () => {
  //   sessionManager.triggerLogout();
  // };

  return (
    // <LogoutWarningModal
    //   isOpen={sessionState.showLogoutWarning}
    //   onLogoutNow={handleLogoutNow}
    //   countdownSeconds={30}
    // />

    null
  );
};
